export enum ProductStates {
  UNKNOWN = 'Unknown',
  UNDEFINED = 'Undefined',
  NEW = 'New',
  USED = 'Used',
  RECONDITIONED = 'Reconditioned',
}
